import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { SESClient } from '@aws-sdk/client-ses';
import { S3Client } from '@aws-sdk/client-s3';
import awsConfig from '../amplifyconfiguration.json';
import { LambdaClient } from "@aws-sdk/client-lambda";
import { fetchAuthSession } from "aws-amplify/auth";

const credentialProvider = async () => {
    const session = await fetchAuthSession();
    if (!session.credentials) {
        throw new Error("No IAM credentials available in the current Auth session");
    }
    return session.credentials;
};

export const client = new CognitoIdentityProviderClient({
    region: awsConfig.aws_cognito_region,
    credentials: credentialProvider
});

export const dbClient = new DynamoDBClient({
    region: awsConfig.aws_cognito_region,
    credentials: credentialProvider
});

export const sesClient = new SESClient({
    region: awsConfig.aws_cognito_region,
    credentials: credentialProvider
});

export const s3Client = new S3Client({
    region: awsConfig.aws_cognito_region,
    credentials: credentialProvider,
});

export const lambdaClient = new LambdaClient({
    region: awsConfig.aws_cognito_region,
    credentials: credentialProvider
});